<template>
  <div class="text-search-cont">
    <v-autocomplete
        v-model="model"
        :items="genreList"
        :item-text="(i) => `${i['genre-ko']} - ${i['genre-en']}`"
        item-value="code"
        @input="changeValue"
        label="장르 검색하기"
        persistent-hint
        prepend-icon="search"
    >
    </v-autocomplete>
  </div>
</template>

<script>
  export default {
    props: {
      genreList: {
        type: Array,
        required: true
      },
    },
    data() {
      return {
        model: null,
      }
    },
    methods: {
      changeValue (val) {
        this.$emit('changeValue', val);
      }
    },
  }
</script>

<style scoped>
.text-search-cont {
  width: 100%;
}
</style>